import React, { useState } from 'react';

import { DataObjectOutlined } from '@mui/icons-material';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

import CodeExampleDialog from './CodeExampleDialog';

export default function CodeExamplesLink() {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ListItemButton onClick={() => setOpen(true)}>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <DataObjectOutlined sx={{ fontSize: 18 }} />
        </ListItemIcon>
        <ListItemText primary="Code examples" />
      </ListItemButton>
      <CodeExampleDialog open={open} handleClose={handleClose} />
    </>
  );
}
